import React from 'react'
import Navbar from '../../components/navbar'
import APK from '../../static/app/ReanHRMS.apk'

const Download = () => {
  return (
    <div className='section-nav download'>
      <Navbar />
      <div className='download-container flexbox'>
        <div className='sub-heading'>Download the Rean HR App</div>
        <a
          href={APK}
          target='_blank'
          download='ReanHRMS.apk'
          className='btn btn-primary'
        >
          Download App
        </a>
      </div>
    </div>
  )
}

export default Download
